import { render, staticRenderFns } from "./GRCControlForm.vue?vue&type=template&id=62fbc469&scoped=true&"
import script from "./GRCControlForm.vue?vue&type=script&lang=js&"
export * from "./GRCControlForm.vue?vue&type=script&lang=js&"
import style0 from "./GRCControlForm.vue?vue&type=style&index=0&id=62fbc469&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fbc469",
  null
  
)

export default component.exports